import './App.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to TAPP Group Extensions</h1>
        <p>Your trusted partner for Shopify extensions</p>
        <div style={{ marginTop: '2rem', fontSize: '1.2rem' }}>
          <p>We create powerful, easy-to-use Shopify extensions</p>
          <p>to enhance your store's functionality and customer experience.</p>
        </div>
        <div style={{ marginTop: '3rem' }}>
          <Link to="/privacy" style={{ color: '#61dafb', textDecoration: 'none', fontSize: '1rem' }}>
            Privacy Policy
          </Link>
        </div>
      </header>
    </div>
  );
}

export default Home;
